import * as modules from './modules'

const { version } = require('./../../../../package.json');

export default {
    state: {
        applicationName : 'ASAHI JAYA PART',
        classDisplay : {
            table : 'table table-bordered table-sm table-striped mb-1 table-mobileable',
            tableHeader : 'bg-info text-light',
            vSelect: 'bg-light text-dark rounded border small'
        },
        logo : 'image/asahi/logo.png',
        logoLong : 'image/asahi/logoLongWhite.png',
        version
    },
    getters: {

    },
    mutations: {

    },
    actions: {
        
    },
    modules

}
